import { PieChartRenderer } from '@leverege/ui-attributes-graphs';
import { Config } from '@leverege/plugin';
import React, { useMemo } from 'react';
import NoChartDataView from "../views/NoChartDataView.js";
import { jsx as _jsx } from "react/jsx-runtime";
export default function PieChartView(props) {
  const {
    settings,
    data,
    loading,
    objectType
  } = props;
  const fData = useMemo(() => {
    return data.items.filter(item => item != null);
  }, [data]);
  let noDataMessage = Config.get(PieChartView.CLIENT, 'noChartDataMessage', NoChartDataView);
  if (noDataMessage != null && typeof noDataMessage !== 'string') {
    // assume its a component class/function
    const Clazz = noDataMessage;
    noDataMessage = /*#__PURE__*/_jsx(Clazz, {
      ...props,
      client: PieChartView.CLIENT
    });
  }
  return /*#__PURE__*/_jsx(PieChartRenderer, {
    loading: loading,
    noDataMessage: noDataMessage,
    model: settings,
    objectType: objectType,
    data: fData
  });
}
PieChartView.CLIENT = 'PieChartDataViewer';